import React, {useContext, useState, } from 'react';
import {Typography, Space, Alert, Form, Input, Button, Row, } from 'antd';
import { DeleteOutlined, WarningFilled,} from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';
import { NocContext } from '../../../context/noc-context';
import { deleteCustomer } from '../../../services/UserService';
import { useNotificationApi } from '../../UI/NotificationProvider';

const { Text, Paragraph, } = Typography;

export const NocDeleteCustomerModal = ({dataSource, displayModal, setDisplayModal, refreshHandler, }) => {

    const notificationApi = useNotificationApi();
    const [nocState, nocDispatch ] = useContext(NocContext);
    const {id, username, companyName, Places, } = dataSource;

    const [displayErrorMessage, setDisplayErrorMessage] = useState(false);

    const alertMessage = (
        <>
            <Text strong style={{color: 'var(--error-color)'}}>
                {companyName}<br/>
                Total Stations: {Places?.length} <br/>
            </Text>
        </>
    );

    const onDeleteHandler = () => {
        deleteCustomer({customerUsername: username}).then((response) => {
            if(response.result){
                setDisplayErrorMessage(false);
                setDisplayModal(false);
                nocDispatch({
                    type: 'DELETE_CUSTOMER', 
                    payload: id,
                })
                refreshHandler();
                setTimeout(() => {
                    notificationApi['success']({
                        message: 'Success',
                        description: `Customer: ${companyName} has been successfully removed.`,  
                        duration: 6,
                    });
                }, 2000)
            } else {
                setDisplayErrorMessage(true);
            }
        });
    }

    return (
        <>
            <Modal
                icon={<WarningFilled/>}
                color="var(--error-color)"
                title="Delete Customer"
                justifyTitle="middle"
                visible={displayModal}
                setVisible={setDisplayModal}
                actionGroup={false}
            >

                <Space direction='vertical'>
                    {displayErrorMessage ? 
                        <Alert type='error' showIcon description=<Text strong style={{color: "var(--error-color)"}}>Something went wrong trying to delete this user. Please try again.</Text>/>
                        :
                        <Alert
                            message= {alertMessage}
                            type="error"
                            closable={false}
                            style={{marginBottom: 15, textAlign: 'center'}}
                        />
                    }

                    <Text>You'll permanently lose all data associated to this account. <strong>Are you sure you want to proceed?</strong></Text>
                    <Paragraph>Please type <strong>"DELETE"</strong> to confirm: </Paragraph>
                </Space>

                <Form
                    name='deleteDeviceForm'
                    autoComplete='off'
                    layout='vertical'
                    preserve={false}
                    onFinish={() => {onDeleteHandler()}}
                    onFieldsChange={() => setDisplayErrorMessage(false)}
                    >
                    <Form.Item 
                        name='delete'
                        rules={[
                            {
                                required: true,
                                validateTrigger: 'onSubmit',
                                validator: (_, value) => {
                                        if(value === 'DELETE'){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Please enter "DELETE" if you want to proceed.'));
                                    }
                                }
                            ]}
                        >
                        <Input style={{textAlign: 'center', }} onInput={(e) => e.target.value = e.target.value.toUpperCase()}/>
                    </Form.Item>
                    <Row justify='end'>   
                        <Form.Item noStyle>
                            <Space>
                                <Button onClick={() => setDisplayModal(false)}>Cancel</Button>
                                <Button htmlType='submit' type='primary' danger icon={<DeleteOutlined/>}>Yes, delete account</Button>
                            </Space>
                        </Form.Item>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}